export function expectEl<T extends Element = HTMLElement>(
    query: string,
    root: HTMLElement | Document = document,
): T {
    const el = root.querySelector<T>(query);
    if (!el) {
        throw new Error(`Expected element with query "${query}"`);
    }
    return el;
}

export function expectEls<T extends Element = HTMLElement>(
    query: string,
    root: HTMLElement | Document = document,
): T[] {
    const els = root.querySelectorAll<T>(query);
    return Array.from(els);
}
